import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../dist/img/logo.png";
import { useUserStore } from "../../store/user_store";

// Beautiful SVG Icons for a premium look
const PlusIcon = () => (
  <svg className="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
  </svg>
);

const MenuIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

const CloseIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
  </svg>
);

const UserIcon = () => (
  <svg className="w-5 h-5 mr-3 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
  </svg>
);

const RegisterIcon = () => (
  <svg className="w-5 h-5 mr-3 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
  </svg>
);

const FileIcon = () => (
  <svg className="w-5 h-5 mr-3 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 13h6m-3-3v3m5 9H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);

const CabinetIcon = () => (
  <svg className="w-5 h-5 mr-3 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
  </svg>
);

const StarIcon = () => (
  <svg className="w-5 h-5 mr-3 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.907c.969 0 1.371 1.24.588 1.81l-3.97 2.883a1 1 0 00-.364 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.971-2.883a1 1 0 00-1.178 0l-3.97 2.883c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.364-1.118L2.98 12.08c-.783-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
  </svg>
);

const MessageIcon = () => (
  <svg className="w-5 h-5 mr-3 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
  </svg>
);

const SettingIcon = () => (
  <svg className="w-5 h-5 mr-3 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const LogoutIcon = () => (
  <svg className="w-5 h-5 mr-3 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
  </svg>
);

const Navbar = () => {
  const history = useNavigate();
  const [visible, setVisible] = useState(false);
  const userState = useUserStore();
  const isAuth = userState.isAuthenticated;
  const showDrawer = () => setVisible(true);
  const hideDrawer = () => setVisible(false);
  const navigateTo = (page) => {
    hideDrawer();
    history(page);
  };
  const logOut = () => {
    localStorage.removeItem("token");
    userState.signOut();
    navigateTo("/");
  };

  return (
    <div className="relative z-50">
      {/* Mobile Navbar */}
      <div className="lg:hidden px-4 py-3 bg-white border-b flex flex-row items-center justify-between">
        <div>
          <Link className="block" to="/" onClick={hideDrawer}>
            <img src={logo} alt="Logo" className="w-[150px] object-contain" />
          </Link>
        </div>
        <div className="flex items-center gap-3">
          <Link
            to="/products/create"
            className="flex items-center gap-1 px-3 py-1.5 bg-blue-600 text-white text-sm font-semibold rounded-xl hover:bg-blue-700 transition"
          >
            <PlusIcon />
            <span className="hidden md:inline">Подать объявление</span>
          </Link>
          <button
            className="p-2 rounded-xl border border-slate-200 text-slate-700 hover:bg-slate-50 transition"
            onClick={showDrawer}
            aria-label="Open menu"
          >
            <MenuIcon />
          </button>
        </div>
      </div>

      {/* Mobile Drawer Overlay */}
      {visible && (
        <div
          className="fixed inset-0 bg-black/45 backdrop-blur-sm z-40 transition-opacity duration-300 animate-fade-in"
          onClick={hideDrawer}
        />
      )}

      {/* Mobile Drawer Container */}
      <div
        className={`fixed top-0 right-0 h-full w-[290px] bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-out flex flex-col ${
          visible ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="p-4 border-b flex justify-between items-center bg-slate-50">
          <span className="text-lg font-bold text-slate-800">Меню</span>
          <button
            onClick={hideDrawer}
            className="p-1 rounded-lg text-slate-500 hover:bg-slate-200 transition"
          >
            <CloseIcon />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto py-3 px-2 space-y-1">
          {!isAuth ? (
            <>
              <button
                onClick={() => navigateTo("/register")}
                className="w-full flex items-center px-4 py-3 text-slate-700 font-medium rounded-xl hover:bg-slate-100 transition text-left"
              >
                <RegisterIcon />
                <span>Регистрация</span>
              </button>
              <button
                onClick={() => navigateTo("/login")}
                className="w-full flex items-center px-4 py-3 text-slate-700 font-medium rounded-xl hover:bg-slate-100 transition text-left"
              >
                <UserIcon />
                <span>Войти</span>
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigateTo("/products/create")}
                className="w-full flex items-center px-4 py-3 text-blue-700 font-semibold rounded-xl hover:bg-blue-50 transition text-left"
              >
                <FileIcon />
                <span>+ Подать объявление</span>
              </button>
              <button
                onClick={() => navigateTo("/profile")}
                className="w-full flex items-center px-4 py-3 text-slate-700 font-medium rounded-xl hover:bg-slate-100 transition text-left"
              >
                <CabinetIcon />
                <span>Личный кабинет</span>
              </button>
              <button
                onClick={() => navigateTo("/favorites")}
                className="w-full flex items-center px-4 py-3 text-slate-700 font-medium rounded-xl hover:bg-slate-100 transition text-left"
              >
                <StarIcon />
                <span>Избранные</span>
              </button>
              <button
                onClick={() => navigateTo("/chats")}
                className="w-full flex items-center px-4 py-3 text-slate-700 font-medium rounded-xl hover:bg-slate-100 transition text-left"
              >
                <MessageIcon />
                <span>Сообщения</span>
              </button>
              <button
                onClick={() => navigateTo("/settings")}
                className="w-full flex items-center px-4 py-3 text-slate-700 font-medium rounded-xl hover:bg-slate-100 transition text-left"
              >
                <SettingIcon />
                <span>Настройки</span>
              </button>
              <button
                onClick={logOut}
                className="w-full flex items-center px-4 py-3 text-red-600 font-medium rounded-xl hover:bg-red-50 transition text-left mt-4 border-t pt-4"
              >
                <LogoutIcon />
                <span>Выйти из профиля</span>
              </button>
            </>
          )}
        </div>
      </div>

      {/* Desktop Navbar */}
      <div className="hidden lg:flex bg-slate-50 border-b">
        <div className="container mx-auto px-4">
          <header className="blog-header py-4 flex justify-between items-center">
            <div className="flex items-center gap-6">
              <Link className="block mr-4" to="/">
                <img src={logo} alt="Logo" className="w-[180px] object-contain" />
              </Link>
              <nav className="flex gap-6 text-sm font-medium text-slate-600">
                <Link to="/" className="hover:text-blue-600 transition">Главная</Link>
                <Link to="/" className="hover:text-blue-600 transition">Для бизнеса</Link>
                <Link to="/articles" className="hover:text-blue-600 transition">Статьи</Link>
                <Link to="/help" className="hover:text-blue-600 transition">Помощь</Link>
                <Link to="/about" className="hover:text-blue-600 transition">О нас</Link>
              </nav>
            </div>
            <div className="flex items-center">
              {!isAuth ? (
                <div className="flex items-center gap-4 text-sm font-semibold">
                  <Link to="/login" className="text-slate-700 hover:text-blue-600 transition">Войти</Link>
                  <span className="text-slate-300">|</span>
                  <Link to="/register" className="text-slate-700 hover:text-blue-600 transition">Регистрация</Link>
                  <Link
                    to="/products/create"
                    className="bg-blue-600 hover:bg-blue-700 text-white rounded-xl px-4 py-2 flex items-center gap-1.5 transition shadow-sm shadow-blue-100"
                  >
                    <PlusIcon /> Разместить объявление
                  </Link>
                </div>
              ) : (
                <div className="flex items-center gap-5 text-slate-700">
                  <Link to="/profile/chats" className="hover:text-blue-600 transition p-1" title="Сообщения">
                    <MessageIcon />
                  </Link>
                  <Link to="/profile" className="hover:text-blue-600 transition p-1" title="Личный кабинет">
                    <UserIcon />
                  </Link>
                  <button onClick={logOut} className="hover:text-red-600 transition p-1" title="Выйти">
                    <LogoutIcon />
                  </button>
                  <Link
                    to="/products/create"
                    className="bg-blue-600 hover:bg-blue-700 text-white rounded-xl px-4 py-2 flex items-center gap-1.5 transition shadow-sm shadow-blue-100 text-sm font-semibold"
                  >
                    <PlusIcon /> Разместить объявление
                  </Link>
                </div>
              )}
            </div>
          </header>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
